module.exports = __webpack_public_path__ + "static/images/trike.1kkkotb.svg";